/** Línea calle + número desde Places Details. */
export function calleLineaDesdePlaces(parts) {
  if (!parts) return "";
  const linea = [parts.calle, parts.numero].filter(Boolean).join(" ").trim();
  return linea || parts.calle || "";
}

/** Dirección completa (calle, CP, población, provincia) para compradores. */
export function direccionCompletaDesdePlaces(parts) {
  if (!parts) return "";
  const calle = calleLineaDesdePlaces(parts);
  const resto = [parts.codigo_postal, parts.poblacion, parts.provincia].filter(Boolean).join(" ");
  return [calle, resto].filter(Boolean).join(", ");
}

/** Rellena dirección (solo calle), población, provincia y CP desde Places. */
export function camposDireccionDesdePlaces(parts, fallback = {}) {
  if (!parts) return {};
  return {
    direccion: calleLineaDesdePlaces(parts) || fallback.direccion || "",
    poblacion: parts.poblacion || fallback.poblacion || "",
    provincia: parts.provincia || fallback.provincia || "",
    codigo_postal: parts.codigo_postal || fallback.codigo_postal || "",
  };
}

/**
 * Domicilio de propietario/contacto: calle y número en campos distintos
 * (igual que la APP). No sustituye `camposDireccionDesdePlaces`.
 */
export function camposDomicilioContactoDesdePlaces(parts, fallback = {}) {
  if (!parts) return {};
  const rawPais = String(parts.pais_codigo || "").trim().toUpperCase()
    || String(parts.pais || "").trim().toUpperCase();
  const pais = /^[A-Z]{2}$/.test(rawPais) ? rawPais : (fallback.pais || "ES");
  const next = {
    direccion: String(parts.calle || fallback.direccion || "").trim(),
    poblacion: parts.poblacion || fallback.poblacion || "",
    provincia: parts.provincia || fallback.provincia || "",
    codigo_postal: parts.codigo_postal || fallback.codigo_postal || "",
    pais,
  };
  if (parts.numero) next.numero = parts.numero;
  else if (fallback.numero) next.numero = fallback.numero;
  if (!fallback.puerta && (parts.puerta || parts.portal)) {
    next.puerta = parts.puerta || parts.portal;
  }
  return next;
}

/** Separa una dirección compuesta guardada (p. ej. "Calle, 03700 Dénia Alicante"). */
export function separarDireccionCompuesta(direccion) {
  const d = String(direccion || "").trim();
  if (!d) return { direccion: "", poblacion: "", provincia: "", codigo_postal: "" };
  const cpMatch = d.match(/,\s*(\d{5})\s+([^,]+?)(?:\s+([A-Za-zÀ-ÿ][^,]*))?\s*$/);
  if (cpMatch) {
    const calle = d.slice(0, cpMatch.index).trim().replace(/,\s*$/, "");
    return {
      direccion: calle,
      codigo_postal: cpMatch[1],
      poblacion: (cpMatch[2] || "").trim(),
      provincia: (cpMatch[3] || "").trim(),
    };
  }
  const partes = d.split(",").map((s) => s.trim()).filter(Boolean);
  if (partes.length >= 3) {
    return {
      direccion: partes.slice(0, -2).join(", "),
      poblacion: partes[partes.length - 2],
      provincia: partes[partes.length - 1],
      codigo_postal: "",
    };
  }
  if (partes.length === 2) {
    return {
      direccion: partes[0],
      poblacion: partes[1],
      provincia: "",
      codigo_postal: "",
    };
  }
  return { direccion: d, poblacion: "", provincia: "", codigo_postal: "" };
}
